export default "__VITE_ASSET__B3YA82By__"